<template>
	<CreationWizardStepWrapper>
		<template #header>
			<GoToAddOnAppHeader v-bind="$props" v-on="$listeners" />
		</template>
		<GoToAddOnAppContentDataProvider
			:appId="selectedAppId"
			:credentialsId="selectedCredentialsConfiguration.id"
			:featureType="selectedFeatureTypeId"
			:placementId="selectedPlacementId"
			:placementVersionId="selectedPlacementVersionId"
			:contextId="selectedContextId"
			:projectId="selectedProjectId"
			:paramsMap="selectedPlacementParamsMap"
			:paramsMapLabels="selectedPlacementParamsMapLabels"
			:elementType="selectedElementType"
			:startCreationProcessOnCreated="extensionMode || embeddedMode"
			v-on="$listeners"
		/>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import GoToAddOnAppHeader from './GoToAddOnAppHeader.vue';
import GoToAddOnAppContentDataProvider from './GoToAddOnAppContentDataProvider.vue';
import props from './GoToAddOnApp.props';
export default {
	name: 'GoToAddOnApp',
	props,
	mixins: [WizardStepMixin],
	components: { GoToAddOnAppHeader, GoToAddOnAppContentDataProvider },
};
</script>

<style lang="scss" scoped></style>
